/* JSQ premium PDP v8 | explicit variant state controller + zero-price purchase guard | Jul 25, 2026 */
(function(){
'use strict';
var root=document.querySelector('.mp-page');
if(!root||root.dataset.mpInitialized==='true')return;
root.dataset.mpInitialized='true';
root.classList.add('is-mp-enhanced');
var localeRoot=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';

var slides=[].slice.call(root.querySelectorAll('[data-mp-slide]'));
var thumbs=[].slice.call(root.querySelectorAll('[data-mp-thumb]'));
var idx=0;
for(var activeIndex=0;activeIndex<slides.length;activeIndex++){
  if(slides[activeIndex].classList.contains('is-active')){idx=activeIndex;break;}
}
function show(i){
  if(!slides.length)return;
  idx=(i+slides.length)%slides.length;
  slides.forEach(function(slide,n){
    var on=n===idx;
    slide.classList.toggle('is-active',on);
    slide.setAttribute('aria-hidden',on?'false':'true');
    slide.tabIndex=on?0:-1;
  });
  thumbs.forEach(function(thumb,n){
    var on=n===idx;
    thumb.classList.toggle('is-active',on);
    if(on)thumb.setAttribute('aria-current','true');else thumb.removeAttribute('aria-current');
  });
}
show(idx);
thumbs.forEach(function(thumb,n){thumb.addEventListener('click',function(){show(n);});});
var prev=root.querySelector('[data-mp-prev]');
var next=root.querySelector('[data-mp-next]');
if(prev)prev.addEventListener('click',function(){show(idx-1);});
if(next)next.addEventListener('click',function(){show(idx+1);});

var qty=root.querySelector('[data-mp-qty-input]');
function emit(element,name){
  if(!element)return;
  var event;
  try{event=new Event(name,{bubbles:true});}
  catch(error){event=document.createEvent('Event');event.initEvent(name,true,false);}
  element.dispatchEvent(event);
}
var quantitySummary=root.querySelector('[data-mp-quantity-summary]');
var quantityEstimate=root.querySelector('[data-mp-quantity-estimate]');
var quantityError=root.querySelector('[data-mp-quantity-error]');
var quantityRules=root.querySelector('[data-mp-quantity-rules]');
var stickyQuantity=root.querySelector('[data-mp-sticky-qty]');
var quantitySteps=Array.from(root.querySelectorAll('[data-mp-qty], [data-mp-sticky-step]'));
var quantityEdited=false;
var quantityVariantId='';

var form=root.querySelector('#mp-product-form');
var atc=root.querySelector('.mp-atc');
var sticky=root.querySelector('[data-mp-sticky-atc]');
var stickyImage=root.querySelector('[data-mp-sticky-image]');
var dyn=root.querySelector('.mp-dynamic-checkout');
var pickup=root.querySelector('[data-mp-pickup-container]');
var giftModule=root.querySelector('[data-mp-gift-module]');
var giftJs=root.querySelector('[data-mp-gift-js]');
var giftFallback=root.querySelector('[data-mp-gift-fallback]');
var giftToggle=root.querySelector('[data-mp-gift-toggle]');
var giftExtra=root.querySelector('[data-mp-gift-extra]');
var giftMessage=root.querySelector('[data-mp-gift-message]');
var giftWrapVariantId=parseInt(root.getAttribute('data-mp-gift-wrap-variant-id'),10)||0;
var giftSubmitting=false;
var variantsEl=root.querySelector('[data-mp-variants]');
var variants=[];
try{variants=JSON.parse((variantsEl&&variantsEl.textContent)||'[]');}catch(error){variants=[];}
var selects=[].slice.call(root.querySelectorAll('[data-mp-option]'));
var optionsRoot=root.querySelector('[data-mp-options]');
var volumeRefreshers=[];
var unavailableLabel=optionsRoot&&optionsRoot.dataset.unavailableLabel||'Unavailable';
var soldoutLabel=optionsRoot&&optionsRoot.dataset.soldoutLabel||'Sold out';
selects.forEach(function(select){
  Array.from(select.options).forEach(function(option){option.dataset.mpBaseLabel=option.textContent;});
  var values=Array.from(select.options).filter(function(option){return !!option.value;});
  if(values.length===1)select.value=values[0].value;
});
var combinedChoices=[];
var combinedRows=[];
var combinedOptions=root.querySelector('[data-mp-combined-options], [data-mp-kittel-options]');
if(combinedOptions&&selects.length===1&&variants.length>1){
  var canonical=selects[0];
  var parsed=variants.map(function(variant){
    var value=variant.options&&variant.options.length===1?variant.options[0]:'';
    var parts;
    if(combinedOptions.dataset.mpCombinedOptions==='tallis'){
      parts=value.split(' / ');
      if(parts.length!==2&&parts.length!==3)return null;
      if(!/^\d+(?: - [^(]+)? \(\d+(?:\.\d+)?["″] x \d+(?:\.\d+)?["″]\)$/.test(parts[0]))return null;
      if(!/^(?:None|(?:Lining|Sideband|Middle-Band)(?: & (?:Lining|Sideband|Middle-Band))*)$/i.test(parts[parts.length-1]))return null;
      if(parts.length===3&&!/^(?:Regular \(Thin\)|Thick \(Talis\)|Meyuchad|No Tzitzis|Thick Belz Chilyos)$/.test(parts[1]))return null;
    }else{
      var match=value.match(/^(.+?) \/ (\d+(?:\.\d+)?["″] Long)(?: \/ (Cotton|Polycotton|Linen))?$/);
      if(!match)return null;
      parts=match.slice(1).filter(Boolean);
    }
    return {value:value,parts:parts,variant:variant};
  });
  var uniqueValues=new Set(parsed.filter(Boolean).map(function(item){return item.parts.join(' | ');}));
  if(parsed.every(function(item){return item&&item.parts.length===parsed[0].parts.length;})&&uniqueValues.size===variants.length){
    combinedRows=parsed;
    var labels=combinedOptions.dataset.mpCombinedOptions==='tallis'
      ? (parsed[0].parts.length===3?[combinedOptions.dataset.sizeLabel,combinedOptions.dataset.tzitzisLabel,combinedOptions.dataset.finishingLabel]:[combinedOptions.dataset.sizeLabel,combinedOptions.dataset.finishingLabel])
      : [combinedOptions.dataset.sizeLabel,combinedOptions.dataset.lengthLabel,combinedOptions.dataset.fabricLabel].slice(0,parsed[0].parts.length);
    var selectedRow=combinedRows.find(function(item){return item.value===canonical.value;});
    var group=document.createElement('div');
    group.className='mp-separated-options';
    labels.forEach(function(label,index){
      var field=document.createElement('div');
      field.className='mp-separated-option';
      var labelEl=document.createElement('label');
      var select=document.createElement('select');
      select.id='mp-combined-'+root.dataset.productId+'-'+index;
      select.className='mp-option-dropdown';
      select.dataset.mpChoiceLabel=label;
      labelEl.htmlFor=select.id;
      labelEl.textContent=label;
      var placeholder=document.createElement('option');
      placeholder.value='';
      placeholder.textContent=combinedOptions.dataset.chooseLabel+' '+label.toLowerCase();
      select.appendChild(placeholder);
      var values=Array.from(new Set(combinedRows.map(function(item){return item.parts[index];})));
      values.forEach(function(value){
        var option=document.createElement('option');
        option.value=value;
        option.textContent=value;
        select.appendChild(option);
      });
      select.value=selectedRow?selectedRow.parts[index]:(values.length===1?values[0]:'');
      select.addEventListener('change',function(){
        combinedChoices.forEach(function(choice,laterIndex){
          if(laterIndex<=index||!choice.value)return;
          var compatible=combinedRows.some(function(item){return item.parts.every(function(value,i){return i>laterIndex||!combinedChoices[i].value||value===combinedChoices[i].value;});});
          if(!compatible)choice.value='';
        });
        var values=combinedChoices.map(function(choice){return choice.value;});
        var match=combinedRows.find(function(item){return item.parts.every(function(value,i){return value===values[i];});});
        canonical.value=match?match.value:'';
        emit(canonical,'change');
      });
      field.appendChild(labelEl);
      field.appendChild(select);
      if(index===0){var sizeHelp=canonical.closest('[data-mp-option-row]').querySelector('.mp-option-help');if(sizeHelp)field.appendChild(sizeHelp.cloneNode(true));}
      group.appendChild(field);
      combinedChoices.push(select);
    });
    combinedOptions.appendChild(group);
    canonical.closest('[data-mp-option-row]').hidden=true;
    combinedOptions.classList.add('has-separated-options');
  }
}
function updateCombinedHints(){
  if(!combinedChoices.length)return;
  var values=combinedChoices.map(function(choice){return choice.value;});
  combinedChoices.forEach(function(choice,index){
    Array.from(choice.options).forEach(function(option){
      if(!option.value)return;
      var test=values.slice();
      test[index]=option.value;
      var matches=combinedRows.filter(function(item){return item.parts.every(function(value,i){return i>index||!test[i]||test[i]===value;});});
      var available=matches.some(function(item){return item.variant.available&&Number(item.variant.price)>0;});
      option.disabled=!matches.length;
      option.textContent=option.value+(available?'':' — '+(matches.length?soldoutLabel:unavailableLabel));
    });
  });
}
var idInput=root.querySelector('[data-mp-variant-id]');
var priceEl=root.querySelector('[data-mp-price]');
var pricePrefix=root.querySelector('[data-mp-price-prefix]');
var cmpEl=root.querySelector('[data-mp-compare]');
var saveEl=root.querySelector('[data-mp-save]');
var stockEl=root.querySelector('[data-mp-stockline]');
var summaryEl=root.querySelector('[data-mp-selection-summary]');
var summaryLiveEl=root.querySelector('[data-mp-selection-live]');
var skuEl=root.querySelector('[data-mp-sku]');
var detailSkuEl=root.querySelector('[data-mp-detail-sku]');
var detailAvailabilityEl=root.querySelector('[data-mp-detail-availability]');
var minPrice=parseInt(root.getAttribute('data-product-price'),10)||0;
var priceVaries=root.getAttribute('data-product-price-varies')==='true';
var moneyFormat=root.getAttribute('data-money-format')||'';
var currency=root.getAttribute('data-currency')||'USD';
var productImageId=root.getAttribute('data-product-image-id')||'';
var productImage=root.getAttribute('data-product-image')||'';
var purchaseBlocked=root.getAttribute('data-mp-purchase-blocked')==='true';
var madeToOrder=root.getAttribute('data-mp-made-to-order')==='true';
var isPreorder=root.getAttribute('data-mp-preorder')==='true';
var isEmailGiftCard=root.getAttribute('data-mp-email-gift-card')==='true';
var shippingLeadTime=root.getAttribute('data-mp-shipping-lead-time')||'1–3 business days';
var shippingPromo=root.getAttribute('data-mp-shipping-promo')||'';
var fulfillmentSummary=root.getAttribute('data-mp-fulfillment-summary')||'';
var productionLeadTime=root.getAttribute('data-mp-production-lead-time')||'';
var baseSlideIndex=0;
for(var baseIndex=0;baseIndex<slides.length;baseIndex++){
  if(String(slides[baseIndex].getAttribute('data-mp-image-id'))===String(productImageId)){baseSlideIndex=baseIndex;break;}
}

/* === JSQ PDP sticky dock visibility (2026-07-15)
   Keep the dock hidden above or beside the inline purchase button.
   Reveal it only after the inline CTA has scrolled above the viewport. */
function setupStickyDockVisibility(){
  var dock=root.querySelector('.mp-mobile-sticky');
  if(!dock||!atc)return;
  var mobileQuery=window.matchMedia('(max-width: 980px)');
  var frame=0;

  function updateDock(){
    frame=0;
    var shouldShow=mobileQuery.matches&&atc.getBoundingClientRect().bottom<=0;
    dock.classList.toggle('is-visible',shouldShow);
    dock.setAttribute('aria-hidden',shouldShow?'false':'true');
  }

  function queueDockUpdate(){
    if(frame)return;
    frame=window.requestAnimationFrame(updateDock);
  }

  window.addEventListener('scroll',queueDockUpdate,{passive:true});
  window.addEventListener('resize',queueDockUpdate,{passive:true});
  if(mobileQuery.addEventListener)mobileQuery.addEventListener('change',queueDockUpdate);
  else if(mobileQuery.addListener)mobileQuery.addListener(queueDockUpdate);
  updateDock();
}
setupStickyDockVisibility();

function money(cents){
  try{
    if(window.Shopify&&typeof window.Shopify.formatMoney==='function'){
      return window.Shopify.formatMoney(cents,moneyFormat||undefined);
    }
  }catch(error){}
  try{
    return new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:currency}).format(Number(cents||0)/100);
  }catch(error){
    return (Number(cents||0)/100).toFixed(2)+' '+currency;
  }
}
function optionName(select,index){
  var row=root.querySelector('[data-mp-option-row="'+index+'"]');
  var label=row&&row.querySelector('.mp-option-name');
  return (label&&label.textContent.trim())||select.getAttribute('name')||'option';
}
function selectedValues(){return selects.map(function(select){return select.value||'';});}
var physicalGiftPicker=root.querySelector('[data-gift-card-picker]');
var physicalGiftVariant=null;
function resolveState(){
  if(purchaseBlocked)return {kind:'blocked',variant:null,values:selectedValues()};
  if(physicalGiftPicker){
    var physicalVariant=physicalGiftVariant;
    return {kind:physicalVariant?(Number(physicalVariant.price)>0?(physicalVariant.available?'available':'soldout'):'pricing'):'incomplete',variant:physicalVariant,values:physicalVariant?[String(physicalVariant.amount)]:[]};
  }
  if(!variants.length)return {kind:'error',variant:null,values:selectedValues()};
  if(variants.length===1){
    if(Number(variants[0].price)<=0)return {kind:'pricing',variant:variants[0],values:variants[0].options||[]};
    return {kind:variants[0].available?'available':'soldout',variant:variants[0],values:variants[0].options||[]};
  }
  var values=selectedValues();
  if(combinedChoices.length&&combinedChoices.every(function(choice){return !!choice.value;})&&!values[0])return {kind:'invalid',variant:null,values:combinedChoices.map(function(choice){return choice.value;})};
  if(!values.length||values.some(function(value){return !value;}))return {kind:'incomplete',variant:null,values:values};
  var variant=variants.find(function(item){
    return item.options&&item.options.length===values.length&&item.options.every(function(value,index){return value===values[index];});
  })||null;
  if(!variant)return {kind:'invalid',variant:null,values:values};
  if(Number(variant.price)<=0)return {kind:'pricing',variant:variant,values:values};
  return {kind:variant.available?'available':'soldout',variant:variant,values:values};
}
function setHiddenVariant(variant){
  if(!idInput)return;
  var nextValue=variant?String(variant.id):'';
  var changed=String(idInput.value||'')!==nextValue||idInput.disabled===!!variant;
  idInput.value=nextValue;
  idInput.disabled=!variant;
  if(changed&&variant)emit(idInput,'change');
}
function setButton(button,kind,variant){
  if(!button)return;
  var available=kind==='available';
  var label='Choose options first';
  if(kind==='available'){
    if(isPreorder)label=button===sticky?'Pre-Order Now · '+money(variant.price):'Pre-Order Now';
    else label='Add to cart · '+money(variant.price);
  }
  else if(kind==='soldout')label='Sold out';
  else if(kind==='invalid')label='Combination unavailable';
  else if(kind==='error')label='Options unavailable';
  else if(kind==='blocked')label=root.dataset.mpBlockedButton||'Options under review';
  else if(kind==='pricing')label='Pricing unavailable';
  button.dataset.mpState=kind;
  button.dataset.available=available?'true':'false';
  button.setAttribute('aria-disabled',available?'false':'true');
  if(button===atc)button.disabled=!available;
  var span=button.querySelector('span');
  if(span)span.textContent=label;else button.textContent=label;
}
function purchasePending(){return giftSubmitting||!!(form&&form.dataset.jsqPurchasePending);}
function quantityText(key,values){
  var template=quantitySummary&&quantitySummary.dataset[key]||'';
  Object.keys(values||{}).forEach(function(token){template=template.split('__'+token+'__').join(String(values[token]));});
  return template;
}
function quantityBounds(variant){
  var rule=variant&&variant.quantity_rule||{};
  var min=Number(rule.min);
  var increment=Number(rule.increment);
  min=Number.isSafeInteger(min)&&min>0?min:1;
  increment=Number.isSafeInteger(increment)&&increment>0?increment:1;
  var max=rule.max===null||rule.max===undefined?null:Number(rule.max);
  if(!Number.isSafeInteger(max)||max<0)max=null;
  if(max!==null&&max>=min)max=min+Math.floor((max-min)/increment)*increment;
  // max = real quantity_rule limit only (shown to shoppers). cap = silent ceiling that also respects stock; never displayed as a number.
  var cap=max;
  var inventory=variant&&variant.inventory_quantity;
  if(variant&&variant.inventory_management&&variant.inventory_policy==='deny'&&Number.isSafeInteger(inventory)){
    var stock=Math.max(0,inventory);
    cap=cap===null?stock:Math.min(cap,stock);
    if(cap>=min)cap=min+Math.floor((cap-min)/increment)*increment;
  }
  return {min:min,increment:increment,max:max,cap:cap};
}
function inspectQuantity(variant){
  var bounds=quantityBounds(variant);
  var raw=qty?String(qty.value).trim():'1';
  var count=Number(raw);
  var error='';
  if(!raw||!Number.isSafeInteger(count))error=quantityText('whole');
  else if(bounds.cap!==null&&bounds.cap<bounds.min)error=quantityText('unavailable');
  else if(count<bounds.min)error=quantityText('minimum',{MIN:bounds.min});
  else if(bounds.max!==null&&count>bounds.max)error=quantityText('maximum',{MAX:bounds.max});
  else if(bounds.cap!==null&&count>bounds.cap)error=quantityText('unavailable');
  else if((count-bounds.min)%bounds.increment!==0)error=quantityText('increment',{MIN:bounds.min,STEP:bounds.increment});
  return {valid:!!raw&&Number.isSafeInteger(count)&&count>=bounds.min&&(bounds.cap===null||count<=bounds.cap)&&(count-bounds.min)%bounds.increment===0,count:count,error:error,bounds:bounds};
}
function renderQuantity(state){
  if(!qty)return true;
  var variantId=state.variant?String(state.variant.id):'';
  var bounds=quantityBounds(state.variant);
  if(variantId!==quantityVariantId&&!quantityEdited&&state.variant)qty.value=String(bounds.min);
  quantityVariantId=variantId;
  qty.min=String(bounds.min);
  qty.step=String(bounds.increment);
  if(bounds.max===null)qty.removeAttribute('max');else qty.max=String(bounds.max);
  var check=inspectQuantity(state.variant);
  var available=state.kind==='available';
  var pending=purchasePending();
  var invalid=available&&!check.valid;
  qty.setCustomValidity(invalid?check.error:'');
  qty.setAttribute('aria-invalid',invalid?'true':'false');
  qty.disabled=pending;
  if(sticky)sticky.disabled=pending;
  if(pending){
    if(atc){atc.disabled=true;atc.setAttribute('aria-disabled','true');}
    if(sticky)sticky.setAttribute('aria-disabled','true');
  }
  if(stickyQuantity)stickyQuantity.textContent=String(qty.value).trim()||'—';
  if(quantityError){quantityError.hidden=!invalid;quantityError.textContent=invalid?check.error:'';}
  if(quantityRules){
    var ruleParts=[];
    if(bounds.min>1)ruleParts.push(quantityText('ruleMinimum',{MIN:bounds.min}));
    if(bounds.increment>1)ruleParts.push(quantityText('ruleIncrement',{STEP:bounds.increment}));
    if(bounds.max!==null&&bounds.max>=bounds.min)ruleParts.push(quantityText('ruleMaximum',{MAX:bounds.max}));
    quantityRules.hidden=!available||!ruleParts.length;
    quantityRules.textContent=ruleParts.join(' · ');
  }
  quantitySteps.forEach(function(button){
    var direction=Number(button.getAttribute('data-mp-qty')||button.getAttribute('data-mp-sticky-step'));
    button.disabled=pending||!available||(check.valid&&(direction<0?check.count<=bounds.min:bounds.cap!==null&&check.count>=bounds.cap))||(bounds.cap!==null&&bounds.cap<bounds.min);
  });
  if(quantityEstimate){
    var estimate='';
    var cents=state.variant&&Number(state.variant.price)*check.count;
    if(available&&check.valid&&Number.isSafeInteger(cents)&&cents>0){
      try{
        var formatted=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:quantitySummary.dataset.currency||currency}).format(cents/100);
        estimate=quantityText(check.count===1?'estimateOne':'estimate',{COUNT:check.count,PRICE:formatted});
      }catch(error){}
    }
    quantityEstimate.hidden=!estimate;
    quantityEstimate.textContent=estimate;
  }
  if(available){
    if(!pending){setButton(atc,state.kind,state.variant);setButton(sticky,state.kind,state.variant);}
    if(invalid||pending){
      if(atc){atc.disabled=true;atc.setAttribute('aria-disabled','true');}
      if(sticky){sticky.disabled=pending;sticky.setAttribute('aria-disabled','true');}
      if(invalid&&!pending){
        var label=quantityText('check');
        var atcSpan=atc&&atc.querySelector('span');
        if(atcSpan)atcSpan.textContent=label;else if(atc)atc.textContent=label;
        if(sticky)sticky.textContent=label;
      }
    }else if(sticky)sticky.disabled=false;
  }
  var giftSelected=!!(giftToggle&&giftToggle.checked&&giftWrapVariantId);
  var embossToggle=form&&form.querySelector('[data-emboss-toggle]');
  var embroideryToggle=form&&form.querySelector('[data-emb-toggle]');
  var personalizationSelected=!!((embossToggle&&embossToggle.checked)||(embroideryToggle&&embroideryToggle.checked));
  if(dyn){dyn.hidden=!!physicalGiftPicker||!available||!check.valid||pending||giftSelected||personalizationSelected;dyn.style.display=dyn.hidden?'none':'';}
  return check.valid;
}
function focusQuantity(){
  if(!qty)return;
  qty.scrollIntoView({block:'center',behavior:window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
  qty.focus();
  qty.reportValidity();
}
quantitySteps.forEach(function(button){
  button.addEventListener('click',function(){
    if(!qty||purchasePending())return;
    var state=resolveState();
    if(state.kind!=='available')return;
    var bounds=quantityBounds(state.variant);
    var direction=Number(button.getAttribute('data-mp-qty')||button.getAttribute('data-mp-sticky-step'));
    var count=Number(qty.value);
    var nextCount=bounds.min;
    if(String(qty.value).trim()&&Number.isFinite(count)){
      var offset=(count-bounds.min)/bounds.increment;
      nextCount=bounds.min+(direction>0?Math.floor(offset)+1:Math.ceil(offset)-1)*bounds.increment;
    }
    nextCount=Math.max(bounds.min,nextCount);
    if(bounds.cap!==null)nextCount=Math.min(nextCount,bounds.cap);
    if(!Number.isSafeInteger(nextCount)||nextCount<bounds.min)return;
    qty.value=String(nextCount);
    quantityEdited=true;
    emit(qty,'input');emit(qty,'change');
  });
});
if(form)form.addEventListener('jsq:gc-quantity',function(event){physicalGiftVariant=event.detail.variant;renderQuantity(resolveState());});
if(qty)['input','change'].forEach(function(name){qty.addEventListener(name,function(){quantityEdited=true;renderQuantity(resolveState());});});
function updateOptionPresentation(){
  selects.forEach(function(select,index){
    var value=select.value||'';
    var current=root.querySelector('[data-mp-option-current="'+index+'"]');
    if(current){
      current.textContent=value?optionLabel(select,value):'Required';
      current.classList.toggle('is-required',!value);
    }
    var row=root.querySelector('[data-mp-swatch-row="'+index+'"]');
    if(!row)return;
    var buttons=[].slice.call(row.querySelectorAll('.mp-swatch'));
    var activeButton=null;
    buttons.forEach(function(button){
      var on=button.getAttribute('data-mp-swatch-value')===value;
      button.classList.toggle('is-active',on);
      button.setAttribute('aria-checked',on?'true':'false');
      if(on&&!button.hidden&&!button.disabled)activeButton=button;
    });
    buttons.forEach(function(button,buttonIndex){button.tabIndex=button===(activeButton||buttons.find(function(item){return !item.disabled&&!item.hidden;}))?0:-1;});
  });
  volumeRefreshers.forEach(function(refresh){refresh();});
}
function optionLabel(select,value){
  var option=Array.from(select.options).find(function(item){return item.value===value;});
  return option?(option.dataset.mpBaseLabel||option.textContent):value;
}
function selectionLabels(state){
  if(combinedChoices.length)return combinedChoices.map(function(choice){return choice.value;});
  return state.values.map(function(value,index){return selects[index]?optionLabel(selects[index],value):value;});
}
function optionMatches(values,optionIndex,value){
  return variants.filter(function(variant){
    return variant.options&&variant.options[optionIndex]===value&&variant.options.every(function(part,index){
      return index>=optionIndex||!values[index]||part===values[index];
    });
  });
}
function repairFollowingChoices(changedIndex){
  var values=selectedValues();
  selects.forEach(function(select,index){
    if(index<=changedIndex||!values[index])return;
    if(!optionMatches(values,index,values[index]).length){select.value='';values[index]='';}
  });
}
function updateOptionHints(){
  if(!variants.length||!selects.length)return;
  var values=selectedValues();
  function hint(optionIndex,value){
    var matches=optionMatches(values,optionIndex,value);
    return {exists:matches.length>0,available:matches.some(function(variant){return variant.available&&Number(variant.price)>0;})};
  }
  root.querySelectorAll('.mp-swatch').forEach(function(button){
    var optionIndex=parseInt(button.getAttribute('data-mp-swatch-target'),10);
    if(isNaN(optionIndex))return;
    var value=button.getAttribute('data-mp-swatch-value')||'';
    var state=hint(optionIndex,value);
    button.classList.toggle('is-impossible',!state.exists);
    button.classList.toggle('is-sold-out-option',state.exists&&!state.available);
    button.classList.toggle('is-unavailable',!state.available);
    button.disabled=!state.exists;
    button.setAttribute('aria-disabled',!state.exists?'true':'false');
    var label=optionLabel(selects[optionIndex],value);
    var availabilityText=state.available?'':(state.exists?soldoutLabel:unavailableLabel);
    button.setAttribute('aria-label',label+(availabilityText?' — '+availabilityText:''));
    var status=button.querySelector('[data-mp-option-status]');
    if(!status&&availabilityText){
      status=document.createElement('span');
      status.className='mp-option-status';
      status.setAttribute('data-mp-option-status','');
      status.setAttribute('aria-hidden','true');
      button.appendChild(status);
    }
    if(status){status.textContent=availabilityText;status.hidden=!availabilityText;}
  });
  selects.forEach(function(select,index){
    if(!select.classList.contains('mp-option-dropdown'))return;
    Array.from(select.options).forEach(function(option){
      if(!option.value)return;
      var state=hint(index,option.value);
      option.disabled=!state.exists;
      option.textContent=option.dataset.mpBaseLabel+(state.available?'':' — '+(state.exists?soldoutLabel:unavailableLabel));
    });
  });
}
function renderNeutralPrice(){
  var unavailable=minPrice<=0;
  if(pricePrefix)pricePrefix.hidden=unavailable||!priceVaries;
  if(priceEl)priceEl.textContent=unavailable?'Price unavailable':money(minPrice);
  if(cmpEl)cmpEl.hidden=true;
  if(saveEl){saveEl.hidden=true;saveEl.textContent='';}
}
function renderExactPrice(variant){
  var unavailable=!variant||Number(variant.price)<=0;
  if(pricePrefix)pricePrefix.hidden=true;
  if(priceEl)priceEl.textContent=unavailable?'Price unavailable':money(variant.price);
  var compareAt=variant&&Number(variant.compare_at_price);
  var price=variant?Number(variant.price):0;
  var savings=(compareAt&&compareAt>price)?(compareAt-price):0;
  var hasCompare=!unavailable&&savings>0;
  if(cmpEl){
    cmpEl.hidden=!hasCompare;
    if(hasCompare)cmpEl.textContent=money(compareAt);
  }
  if(saveEl){
    saveEl.hidden=!hasCompare;
    if(hasCompare){
      var percent=Math.round(savings*100/compareAt);
      saveEl.textContent='Save '+money(savings)+(percent>=5?' ('+percent+'%)':'');
    }else{
      saveEl.textContent='';
    }
  }
}
function renderStock(kind,variant){
  var html='';
  var detail='Choose options';
  if(kind==='pricing'){
    html='<span class="mp-stock mp-stock--out">Ordering paused</span><span class="mp-ship">Price confirmation is required before purchase</span>';
    detail='Price confirmation required';
  }else if(kind==='available'&&isEmailGiftCard){
    detail=root.getAttribute('data-mp-email-label')||'Delivered by email';
    html='<span class="mp-stock">'+escapeHTML(detail)+'</span>';
  }else if(isPreorder&&kind==='available'){
    html='<span class="mp-preorder-message">Available for preorder. This title has not yet been released. Your order will ship as soon as it becomes available from the publisher.</span>';
    detail='Available for preorder';
  }else if(kind==='available'){
    var quantity=typeof variant.inventory_quantity==='number'?variant.inventory_quantity:null;
    var low=!!variant.inventory_management&&quantity!==null&&quantity>0&&quantity<10;
    var backorder=!!variant.inventory_management&&quantity!==null&&quantity<=0&&variant.inventory_policy==='continue';
    if(madeToOrder){
      html='<span class="mp-stock mp-stock--order">Custom made for you</span><span class="mp-ship">'+(productionLeadTime?'Production time: '+escapeHTML(productionLeadTime):'Created especially for your order; timing varies by item')+'</span>';
      detail='Custom made for you';
    }else if(backorder){
      html='<span class="mp-stock mp-stock--order">Order now</span><span class="mp-ship">'+escapeHTML(fulfillmentSummary)+'</span>';
      detail='Order now';
    }else{
      html='<span class="mp-stock'+(low?' mp-stock--low':'')+'">'+(low?'Only '+quantity+' left in stock':'In stock')+'</span><span class="mp-ship">'+escapeHTML(shippingPromo)+'</span>';
      detail='In stock';
    }
  }else if(kind==='soldout'){
    html='<span class="mp-stock mp-stock--out">Out of stock</span><span class="mp-ship">WhatsApp us for availability</span>';
    detail='Out of stock';
  }else if(kind==='invalid'){
    html='<span class="mp-stock mp-stock--out">Combination unavailable</span><span class="mp-ship">Change one of the selected options</span>';
    detail='Combination unavailable';
  }else if(kind==='error'){
    html='<span class="mp-stock mp-stock--out">Options unavailable</span><span class="mp-ship">Please refresh the page or contact us</span>';
    detail='Options unavailable';
  }else if(kind==='blocked'){
    html='<span class="mp-stock mp-stock--out">Ordering paused</span><span class="mp-ship">Contact us so we can confirm the correct product options</span>';
    detail='Ordering paused';
  }else{
    html='<span class="mp-stock mp-stock--choose">Choose options</span><span class="mp-ship">See the exact price and availability for your selection</span>';
  }
  if(stockEl)stockEl.innerHTML=html;
  if(detailAvailabilityEl)detailAvailabilityEl.textContent=detail;
}
function renderSku(variant){
  var value=variant?(variant.sku||'Not listed'):'Select options';
  if(skuEl)skuEl.textContent=value;
  if(detailSkuEl)detailSkuEl.textContent=value;
}
function renderSummary(state){
  if(!summaryEl)return;
  summaryEl.classList.toggle('is-incomplete',state.kind!=='available'&&state.kind!=='soldout');
  if(state.kind==='available'){
    summaryEl.textContent='Your selection: '+selectionLabels(state).join(' · ')+' — '+money(state.variant.price);
  }else if(state.kind==='soldout'){
    summaryEl.textContent='Your selection: '+selectionLabels(state).join(' · ')+' — sold out';
  }else if(state.kind==='invalid'){
    summaryEl.textContent="That combination isn't available. Please change an option.";
  }else if(state.kind==='error'){
    summaryEl.textContent='Options could not be loaded. Please refresh the page or contact us.';
  }else if(state.kind==='blocked'){
    summaryEl.textContent=root.dataset.mpBlockedMessage||'Ordering is paused while these mismatched options are corrected.';
  }else if(state.kind==='pricing'){
    summaryEl.textContent='Ordering is paused until the correct price is confirmed.';
  }else{
    var missing=combinedChoices.length?combinedChoices.filter(function(choice){return !choice.value;}).map(function(choice){return choice.dataset.mpChoiceLabel;}):selects.map(function(select,index){return select.value?'':optionName(select,index);}).filter(Boolean);
    summaryEl.textContent='Choose '+missing.join(missing.length>1?' and ':'')+' to continue.';
  }
  if(summaryLiveEl)summaryLiveEl.textContent=summaryEl.textContent;
}
function renderImage(variant){
  var targetIndex=baseSlideIndex;
  if(variant&&variant.featured_image&&variant.featured_image.id){
    for(var imageIndex=0;imageIndex<slides.length;imageIndex++){
      if(String(slides[imageIndex].getAttribute('data-mp-image-id'))===String(variant.featured_image.id)){
        targetIndex=imageIndex;
        break;
      }
    }
  }
  show(targetIndex);
  if(stickyImage){
    stickyImage.src=(slides[targetIndex]&&slides[targetIndex].getAttribute('data-mp-dock-src'))||productImage||stickyImage.src;
  }
}
function updateUrl(state){
  if(!window.history||!window.history.replaceState||!window.URL)return;
  try{
    var url=new URL(window.location.href);
    if(state.variant)url.searchParams.set('variant',String(state.variant.id));else url.searchParams.delete('variant');
    window.history.replaceState(window.history.state,'',url.pathname+url.search+url.hash);
  }catch(error){}
}
function dispatchVariantState(state){
  var event;
  try{event=new CustomEvent('jsq:variant-change',{bubbles:true,detail:{kind:state.kind,variant:state.variant}});}
  catch(error){event=document.createEvent('CustomEvent');event.initCustomEvent('jsq:variant-change',true,false,{kind:state.kind,variant:state.variant});}
  root.dispatchEvent(event);
}
function renderState(userInitiated){
  updateCombinedHints();
  updateOptionHints();
  updateOptionPresentation();
  var state=resolveState();
  var exact=!!state.variant;
  setHiddenVariant(state.kind==='pricing'?null:state.variant);
  if(!purchasePending()){
    setButton(atc,state.kind,state.variant);
    setButton(sticky,state.kind,state.variant);
  }
  renderQuantity(state);
  if(exact)renderExactPrice(state.variant);else renderNeutralPrice();
  renderStock(state.kind,state.variant);
  renderSku(state.variant);
  renderSummary(state);
  if(pickup)pickup.hidden=isPreorder||state.kind!=='available';
  root.dataset.mpSelectionReady=exact?'true':'false';
  root.classList.toggle('needs-selection',state.kind==='incomplete');
  root.classList.toggle('is-invalid-combination',state.kind==='invalid'||state.kind==='error');
  root.classList.toggle('is-purchase-blocked',state.kind==='blocked'||state.kind==='pricing');
  root.classList.toggle('is-price-unavailable',state.kind==='pricing');
  root.classList.toggle('is-sold-out',state.kind==='soldout');
  root.classList.toggle('has-available-variant',state.kind==='available');
  var imageVariant=state.variant||(state.values.some(function(value){return !!value;})?variants.find(function(item){return item.options&&item.options.every(function(value,index){return !state.values[index]||value===state.values[index];})&&item.featured_image&&item.featured_image.id;})||null:null);renderImage(imageVariant);
  if(userInitiated)updateUrl(state);
  dispatchVariantState(state);
  return state;
}
function promptSelection(state){
  state=state||resolveState();
  renderSummary(state);
  if(state.kind==='blocked'||state.kind==='pricing'){
    var alert=root.querySelector(state.kind==='pricing'?'.mp-price-alert':'.mp-catalog-alert');
    if(alert){alert.scrollIntoView({block:'center',behavior:window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});alert.focus();}
    return;
  }
  if(combinedChoices.length){
    var choice=combinedChoices.find(function(item){return !item.value;})||combinedChoices[0];
    choice.scrollIntoView({block:'center'});choice.focus();return;
  }
  var firstMissing=null;
  selects.some(function(select,index){
    if(select.value)return false;
    firstMissing=root.querySelector('[data-mp-option-row="'+index+'"]');
    return true;
  });
  var target=firstMissing||root.querySelector('.mp-options');
  if(target){
    target.classList.add('has-error');
    var focusTarget=target.querySelector('.mp-option-dropdown, .mp-swatch:not([hidden])');
    target.scrollIntoView({block:'center',behavior:window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    if(focusTarget)setTimeout(function(){focusTarget.focus();},120);
  }
}

selects.forEach(function(select,index){select.addEventListener('change',function(){
  if(!combinedChoices.length)repairFollowingChoices(index);
  renderState(true);
});});
var volumeFilters=[].slice.call(root.querySelectorAll('[data-mp-volume-filter]'));
var volumeSearchAliases={
  'berachos':'ברכות','brachos':'ברכות','berachot':'ברכות','berakhot':'ברכות',
  'shabbos':'שבת','shabbat':'שבת','eruvin':'עירובין','eiruvin':'עירובין',
  'pesachim':'פסחים','pesahim':'פסחים','rosh hashanah':'ראש השנה','rosh hashana':'ראש השנה',
  'yoma':'יומא','sukkah':'סוכה','sukah':'סוכה','taanis':'תענית','taanit':'תענית',
  'megillah':'מגילה','megila':'מגילה','moed katan':'מועד קטן','chagigah':'חגיגה','hagigah':'חגיגה',
  'yevamos':'יבמות','yevamot':'יבמות','yevamoth':'יבמות','kesubos':'כתובות','ketubot':'כתובות',
  'nedarim':'נדרים','nazir':'נזיר','sotah':'סוטה','sota':'סוטה','gittin':'גיטין','gitin':'גיטין',
  'kiddushin':'קדושין','kidushin':'קדושין','bava kama':'בבא קמא','baba kama':'בבא קמא',
  'bava metzia':'בבא מציעא','baba metzia':'בבא מציעא','bava basra':'בבא בתרא','bava batra':'בבא בתרא',
  'sanhedrin':'סנהדרין','makkos':'מכות','makkot':'מכות','shevuos':'שבועות','shevuot':'שבועות',
  'avodah zarah':'עבודה זרה','avoda zara':'עבודה זרה','horayos':'הוריות','horayot':'הוריות',
  'bechoros':'בכורות','bekhorot':'בכורות','arachin':'ערכין','arakhin':'ערכין',
  'zevachim':'זבחים','zevahim':'זבחים','chullin':'חולין','chulin':'חולין',
  'menachos':'מנחות','menachot':'מנחות','temurah':'תמורה','temura':'תמורה',
  'meilah':'מעילה','meila':'מעילה','niddah':'נדה','nidah':'נדה'
};
function normalizeVolumeSearch(value){
  var text=String(value||'').toLowerCase().replace(/[\u0591-\u05BD\u05BF-\u05C7]/g,'').replace(/[–—]/g,'-').replace(/[^a-z0-9\u0590-\u05ff]+/g,' ').trim();
  Object.keys(volumeSearchAliases).forEach(function(alias){text=text.replace(new RegExp('\\b'+alias+'\\b','g'),volumeSearchAliases[alias]);});
  return text.replace(/מעוד קטן/g,'מועד קטן');
}
volumeFilters.forEach(function(input){
  var optionIndex=input.getAttribute('data-mp-volume-filter');
  var row=root.querySelector('[data-mp-swatch-row="'+optionIndex+'"]');
  var count=root.querySelector('[data-mp-volume-count="'+optionIndex+'"]');
  var empty=root.querySelector('[data-mp-volume-empty="'+optionIndex+'"]');
  var clear=root.querySelector('[data-mp-volume-clear="'+optionIndex+'"]');
  if(!row)return;
  var buttons=[].slice.call(row.querySelectorAll('.mp-swatch'));
  function filterVolumes(){
    var terms=normalizeVolumeSearch(input.value).split(' ').filter(Boolean);
    var shown=0;
    var retained=false;
    var selected=selects[Number(optionIndex)]&&selects[Number(optionIndex)].value;
    buttons.forEach(function(button){
      var haystack=normalizeVolumeSearch(button.getAttribute('data-mp-swatch-value')||button.textContent);
      var matches=terms.every(function(term){return haystack.indexOf(term)!==-1;});
      var keepSelected=!!selected&&button.getAttribute('data-mp-swatch-value')===selected;
      button.hidden=!matches&&!keepSelected;
      button.setAttribute('aria-hidden',button.hidden?'true':'false');
      if(keepSelected&&!matches)retained=true;
      if(matches)shown++;
    });
    if(count){
      var countLabel=(terms.length?count.dataset.matchLabel:count.dataset.totalLabel)||'__count__ / __total__';
      count.textContent=countLabel.replace('__count__',String(shown)).replace('__total__',String(buttons.length))+(retained&&count.dataset.selectedLabel?' '+count.dataset.selectedLabel:'');
    }
    if(clear)clear.hidden=!input.value;
    if(empty)empty.hidden=shown!==0;
    var visibleButtons=buttons.filter(function(button){return !button.hidden&&!button.disabled;});
    var selectedVisible=visibleButtons.find(function(button){return button.classList.contains('is-active');});
    buttons.forEach(function(button){button.tabIndex=button===(selectedVisible||visibleButtons[0])?0:-1;});
  }
  volumeRefreshers.push(filterVolumes);
  input.addEventListener('input',filterVolumes);
  input.addEventListener('search',filterVolumes);
  input.addEventListener('keydown',function(event){
    if(event.key==='Enter'){event.preventDefault();return;}
    if(event.key==='Escape'&&input.value){event.preventDefault();input.value='';filterVolumes();}
  });
  if(clear)clear.addEventListener('click',function(){input.value='';filterVolumes();input.focus();});
  filterVolumes();
});
var swatches=[].slice.call(root.querySelectorAll('.mp-swatch'));
swatches.forEach(function(button){
  button.addEventListener('click',function(event){
    if(button.disabled)return;
    event.preventDefault();
    var optionIndex=button.getAttribute('data-mp-swatch-target');
    var value=button.getAttribute('data-mp-swatch-value');
    var select=root.querySelector('[data-mp-option-index="'+optionIndex+'"]');
    if(!select)return;
    select.value=value;
    var row=button.closest('[data-mp-option-row]');
    if(row)row.classList.remove('has-error');
    emit(select,'change');
  });
  button.addEventListener('keydown',function(event){
    if(!/^(ArrowLeft|ArrowRight|ArrowUp|ArrowDown|Home|End)$/.test(event.key))return;
    var row=button.closest('[data-mp-swatch-row]');
    if(!row)return;
    var buttons=[].slice.call(row.querySelectorAll('.mp-swatch')).filter(function(candidate){return !candidate.hidden&&!candidate.disabled;});
    if(!buttons.length)return;
    var current=buttons.indexOf(button);
    var nextIndex=current;
    if(event.key==='Home')nextIndex=0;
    else if(event.key==='End')nextIndex=buttons.length-1;
    else if(event.key==='ArrowLeft'||event.key==='ArrowUp')nextIndex=(current-1+buttons.length)%buttons.length;
    else nextIndex=(current+1)%buttons.length;
    event.preventDefault();
    buttons[nextIndex].focus();
    buttons[nextIndex].click();
  });
});
root.querySelectorAll('[data-emboss-toggle]').forEach(function(toggle){toggle.addEventListener('change',function(){renderState(false);});});
function syncGiftState(){
  var selected=!!(giftToggle&&giftToggle.checked&&giftWrapVariantId);
  if(giftExtra)giftExtra.hidden=!selected;
  if(giftMessage){giftMessage.disabled=!selected;if(!selected)giftMessage.value='';}
  renderState(false);
}
if(giftModule&&giftJs&&giftToggle&&giftWrapVariantId){
  giftJs.hidden=false;
  if(giftFallback)giftFallback.hidden=true;
  giftToggle.addEventListener('change',syncGiftState);
  syncGiftState();
}
if(sticky&&form)sticky.addEventListener('click',function(event){
  var state=resolveState();
  event.preventDefault();
  if(purchasePending())return;
  if(state.kind==='available'){
    if(!renderQuantity(state)){focusQuantity();return;}
    if(typeof form.requestSubmit==='function')form.requestSubmit(atc);else atc.click();
  }else if(state.kind==='soldout'){
    if(window.JSQInventoryGuard)window.JSQInventoryGuard.showMessage();
  }else{
    promptSelection(state);
  }
});
if(form)form.addEventListener('jsq:purchase-state',function(){renderState(false);});
if(form)form.addEventListener('jsq:personalization-state',function(){renderQuantity(resolveState());});
if(form)form.addEventListener('submit',function(event){
  if(purchasePending()){event.preventDefault();event.stopImmediatePropagation();return;}
  var state=resolveState();
  if(state.kind==='available'){
    if(!renderQuantity(state)){
      event.preventDefault();event.stopImmediatePropagation();
      focusQuantity();
      return;
    }
    var embossToggle=form.querySelector('[data-emboss-toggle]');
    var embroideryToggle=form.querySelector('[data-emb-toggle]');
    if((embossToggle&&embossToggle.checked)||(embroideryToggle&&embroideryToggle.checked))return;
    if(!giftToggle||!giftToggle.checked||!giftWrapVariantId)return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if(giftSubmitting)return;
    var mainQuantity=Number(qty?qty.value:1);
    var properties={};
    form.querySelectorAll('[name^="properties["]').forEach(function(field){
      if(field.disabled)return;
      if((field.type==='checkbox'||field.type==='radio')&&!field.checked)return;
      var match=field.name.match(/^properties\[(.*)\]$/);
      if(match&&field.value)properties[match[1]]=field.value;
    });
    if(giftMessage&&giftMessage.value.trim())properties['Gift message']=giftMessage.value.trim();
    var mainItem={id:Number(state.variant.id),quantity:mainQuantity};
    if(Object.keys(properties).length)mainItem.properties=properties;
    var sellingPlan=form.querySelector('[name="selling_plan"]');
    if(sellingPlan&&sellingPlan.value)mainItem.selling_plan=Number(sellingPlan.value);
    var items=[mainItem,{id:giftWrapVariantId,quantity:mainQuantity,properties:{'_Gift for':root.getAttribute('data-product-title')||'Product'}}];
    var atcText=atc&&atc.querySelector('span');
    giftSubmitting=true;
    renderQuantity(state);
    if(atc){atc.disabled=true;atc.setAttribute('aria-disabled','true');}
    if(sticky){sticky.disabled=true;sticky.setAttribute('aria-disabled','true');}
    if(atcText)atcText.textContent='Adding gift ribboning…';
    var shopRoot=window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root?window.Shopify.routes.root:'/';
    fetch(shopRoot+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})})
      .then(function(response){if(!response.ok)throw new Error('Cart add failed');return response.json();})
      .then(function(){window.location.assign(shopRoot+'cart');})
      .catch(function(){
        giftSubmitting=false;
        renderState(false);
        if(atcText)atcText.textContent='Please try adding gift ribboning again';
        window.setTimeout(function(){renderState(false);},2400);
      });
    return;
  }
  event.preventDefault();
  event.stopImmediatePropagation();
  renderState(false);
  if(state.kind==='soldout'){
    if(window.JSQInventoryGuard)window.JSQInventoryGuard.showMessage();
  }else{
    promptSelection(state);
  }
},true);
document.addEventListener('jsq:inventory-blocked',function(){
  var state=resolveState();
  if(state.variant)state.variant.available=false;
  renderState(false);
});
renderState(false);


/* === Lightbox zoom (2026-07-02): tap/click any gallery image to open full-screen === */
var lb=null;
var lightboxReturnFocus=null;
function openLightbox(){
  var slide=slides[idx];
  if(!slide)return;
  var src=slide.getAttribute('data-mp-zoom-src')||(slide.querySelector('img')&&slide.querySelector('img').currentSrc);
  if(!src)return;
  if(!lb){
    lb=document.createElement('div');
    lb.className='mp-lightbox';
    lb.setAttribute('role','dialog');
    lb.setAttribute('aria-modal','true');
    lb.setAttribute('aria-label','Product image viewer');
    lb.setAttribute('tabindex','-1');
    lb.innerHTML='<img alt=""><button type="button" class="mp-lb-close" aria-label="Close image viewer">✕</button>'+(slides.length>1?'<button type="button" class="mp-lb-prev" aria-label="Previous product image">‹</button><button type="button" class="mp-lb-next" aria-label="Next product image">›</button>':'');
    lb.addEventListener('click',function(event){if(event.target===lb||event.target.classList.contains('mp-lb-close'))closeLightbox();});
    var lightboxPrev=lb.querySelector('.mp-lb-prev');
    var lightboxNext=lb.querySelector('.mp-lb-next');
    if(lightboxPrev)lightboxPrev.addEventListener('click',function(){show(idx-1);syncLightbox();});
    if(lightboxNext)lightboxNext.addEventListener('click',function(){show(idx+1);syncLightbox();});
    lb.addEventListener('keydown',function(event){
      if(event.key==='Escape'){event.preventDefault();closeLightbox();return;}
      if(event.key==='ArrowLeft'&&lightboxPrev){event.preventDefault();lightboxPrev.click();return;}
      if(event.key==='ArrowRight'&&lightboxNext){event.preventDefault();lightboxNext.click();return;}
      if(event.key!=='Tab')return;
      var controls=[].slice.call(lb.querySelectorAll('button'));
      if(!controls.length)return;
      var first=controls[0],last=controls[controls.length-1];
      if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
      else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
    });
    document.body.appendChild(lb);
  }
  lightboxReturnFocus=document.activeElement;
  lb.hidden=false;
  document.body.style.overflow='hidden';
  syncLightbox();
  var close=lb.querySelector('.mp-lb-close');
  if(close)close.focus();
}
function syncLightbox(){
  if(!lb)return;
  var slide=slides[idx];
  if(!slide)return;
  var sourceImage=slide.querySelector('img');
  var image=lb.querySelector('img');
  image.src=slide.getAttribute('data-mp-zoom-src')||(sourceImage&&sourceImage.currentSrc)||'';
  image.alt=(sourceImage&&sourceImage.alt)||root.getAttribute('data-product-title')||'Product image';
}
function closeLightbox(){
  if(!lb)return;
  emit(lb,'jsq:lightbox-closed');
  lb.hidden=true;
  document.body.style.overflow='';
  var image=lb.querySelector('img');
  if(image){image.style.transform='';image.classList.remove('is-zoomed','is-gesturing');}
  if(lightboxReturnFocus&&typeof lightboxReturnFocus.focus==='function')lightboxReturnFocus.focus();
}
slides.forEach(function(slide){slide.addEventListener('click',function(){if(slide.classList.contains('is-active'))openLightbox();});});

/* === Related products fallback + Recently viewed (2026-07-02) === */
function escapeHTML(value){return String(value||'').replace(/[&<>"']/g,function(character){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[character];});}
function safePath(value){var path=String(value||'');if(!/^(\/|https:\/\/|http:\/\/)/.test(path))return '#';try{var u=new URL(path,location.origin);['pr_prod_strat','pr_rec_id','pr_rec_pid','pr_ref','pr_ref_pid','pr_seq'].forEach(function(k){u.searchParams.delete(k);});return u.pathname+(u.search?u.search:'')+u.hash;}catch(e){return path.split('?')[0];}}
function cardHTML(p){var rawImage=typeof p.image==='string'?p.image:'';var img=rawImage.replace(/^https?:/,'');var title=String(p.title||'').slice(0,80);var priceLabel=(p.priceVaries?'From ':'')+money(p.price);var media=img?'<img src="'+escapeHTML(img)+'" alt="'+escapeHTML(title)+'" loading="lazy" width="360" height="360">':'<span class="mp-recent-placeholder" aria-hidden="true">'+escapeHTML(title)+'</span>';return '<a href="'+escapeHTML(safePath(p.url))+'"><div>'+media+'</div><strong>'+escapeHTML(title)+'</strong><span>'+escapeHTML(priceLabel)+'</span></a>';}
var recoWrap=root.querySelector('[data-mp-reco]'),recoRow=root.querySelector('[data-mp-reco-row]'),pid=root.getAttribute('data-product-id');
if(recoWrap&&recoRow&&pid){
  var recommendationURL=recoWrap.getAttribute('data-jsq-recommendations-url');
  if(recommendationURL){
    fetch(recommendationURL+'?product_id='+encodeURIComponent(pid)+'&section_id=jsq-relevant-recommendations&limit=10&intent=related')
      .then(function(response){return response.ok?response.text():null;})
      .then(function(html){
        if(!html)return;
        var parsed=new DOMParser().parseFromString(html,'text/html');
        var results=parsed.querySelector('[data-jsq-related-results]');
        if(!results||results.getAttribute('data-jsq-reco-source')!==String(pid)||!results.querySelector('[data-jsq-related-product]'))return;
        recoRow.innerHTML=results.innerHTML;
        recoWrap.hidden=false;
      }).catch(function(){});
  }
}
try{
var KEY='jsq_recent_v1',cur={id:pid,url:root.getAttribute('data-product-url'),title:root.getAttribute('data-product-title'),image:root.getAttribute('data-product-image'),price:parseInt(root.getAttribute('data-product-price'),10)||0,priceVaries:root.getAttribute('data-product-price-varies')==='true'};
var stored=JSON.parse(localStorage.getItem(KEY)||'[]');
var recentIds=[];
var list=(Array.isArray(stored)?stored:[]).filter(function(p){
  var id=p&&String(p.id||'');
  if(!/^\d+$/.test(id)||id===String(pid)||recentIds.indexOf(id)!==-1)return false;
  recentIds.push(id);
  return true;
}).slice(0,12);
var rvWrap=root.querySelector('[data-mp-recent]'),rvRow=root.querySelector('[data-mp-recent-row]');
if(rvWrap&&rvRow&&list.length){
  var recentURL=rvWrap.getAttribute('data-jsq-recent-url');
  var recentProducts=list.slice(0,8);
  function renderRecentFallback(){
    var products=recentProducts.filter(function(p){return p.url&&safePath(p.url)!=='#'&&String(p.title||'').trim()&&isFinite(Number(p.price))&&Number(p.price)>0;});
    if(!products.length)return;
    rvRow.innerHTML=products.map(cardHTML).join('');
    rvWrap.hidden=false;
  }
  if(recentURL){
    var requestedIds=recentProducts.map(function(p){return String(p.id);});
    var requestURL=new URL(recentURL,location.origin);
    requestURL.searchParams.set('q',requestedIds.map(function(id){return 'id:'+id;}).join(' OR '));
    requestURL.searchParams.set('type','product');
    requestURL.searchParams.set('options[prefix]','none');
    requestURL.searchParams.set('section_id','jsq-recent-products');
    fetch(requestURL.toString(),{cache:'no-store'})
      .then(function(response){return response.ok?response.text():null;})
      .then(function(html){
        if(!html){renderRecentFallback();return;}
        var parsed=new DOMParser().parseFromString(html,'text/html');
        var results=parsed.querySelector('[data-jsq-recent-results]');
        if(!results){renderRecentFallback();return;}
        var cards=requestedIds.map(function(id){return results.querySelector('[data-jsq-recent-id="'+id+'"]');}).filter(Boolean);
        if(!cards.length){renderRecentFallback();return;}
        rvRow.replaceChildren.apply(rvRow,cards);
        rvWrap.hidden=false;
      }).catch(renderRecentFallback);
  }else{
    renderRecentFallback();
  }
}
if(cur.id&&cur.url&&cur.price>0){list.unshift(cur);localStorage.setItem(KEY,JSON.stringify(list.slice(0,12)));}
}catch(e){}
})();


/* === SPRINT3.7 (2026-07-05): pinch-zoom / pan / double-tap for the existing lightbox.
   Dependency-free Pointer Events module (photoswipe.min.js ships without its CSS, so
   wiring the library would need hand-embedded styles — this is smaller and safer).
   Delegated: works on the lazily-created .mp-lightbox without touching the closure above. */
(function(){'use strict';
if(!window.PointerEvent)return;
var st=document.createElement('style');
st.textContent='.mp-lightbox img{touch-action:none;-webkit-user-drag:none;user-select:none;cursor:zoom-in;transition:transform .15s ease}.mp-lightbox img.is-gesturing{transition:none}.mp-lightbox img.is-zoomed{cursor:grab}';
document.head.appendChild(st);
var img=null,ptrs={},nPtrs=0,scale=1,tx=0,ty=0,g0=null,lastTap=0;
function pts(){var a=[];for(var k in ptrs)a.push(ptrs[k]);return a;}
function apply(){if(!img)return;img.style.transform=(scale!==1||tx||ty)?('translate('+tx+'px,'+ty+'px) scale('+scale+')'):'';img.classList.toggle('is-zoomed',scale>1);}
function reset(){scale=1;tx=0;ty=0;ptrs={};nPtrs=0;g0=null;if(img){img.classList.remove('is-gesturing');apply();}}
document.addEventListener('jsq:lightbox-closed',reset);
function clampPan(){if(!img)return;var mx=(scale-1)*img.clientWidth/2,my=(scale-1)*img.clientHeight/2;tx=Math.max(-mx,Math.min(mx,tx));ty=Math.max(-my,Math.min(my,ty));}
document.addEventListener('pointerdown',function(e){
  var t=e.target;
  if(!(t&&t.tagName==='IMG'&&t.closest&&t.closest('.mp-lightbox')))return;
  img=t;e.preventDefault();
  try{t.setPointerCapture(e.pointerId);}catch(err){}
  ptrs[e.pointerId]={x:e.clientX,y:e.clientY};nPtrs++;
  var p=pts();
  if(nPtrs===2){var dx=p[0].x-p[1].x,dy=p[0].y-p[1].y;g0={dist:Math.hypot(dx,dy)||1,scale:scale,tx:tx,ty:ty,mx:(p[0].x+p[1].x)/2,my:(p[0].y+p[1].y)/2};}
  else if(nPtrs===1){g0={x:e.clientX,y:e.clientY,tx:tx,ty:ty,t:Date.now()};}
  img.classList.add('is-gesturing');
});
document.addEventListener('pointermove',function(e){
  if(!img||!(e.pointerId in ptrs))return;
  ptrs[e.pointerId]={x:e.clientX,y:e.clientY};
  var p=pts();
  if(nPtrs===2&&g0&&g0.dist){var dx=p[0].x-p[1].x,dy=p[0].y-p[1].y,d=Math.hypot(dx,dy);
    scale=Math.max(1,Math.min(4,g0.scale*d/g0.dist));
    var mx=(p[0].x+p[1].x)/2,my=(p[0].y+p[1].y)/2;
    tx=g0.tx+(mx-g0.mx);ty=g0.ty+(my-g0.my);clampPan();apply();e.preventDefault();}
  else if(nPtrs===1&&g0&&typeof g0.x==='number'&&scale>1){tx=g0.tx+(e.clientX-g0.x);ty=g0.ty+(e.clientY-g0.y);clampPan();apply();e.preventDefault();}
});
function up(e){
  if(!img||!(e.pointerId in ptrs))return;
  delete ptrs[e.pointerId];nPtrs=Math.max(0,nPtrs-1);
  if(nPtrs===0){
    img.classList.remove('is-gesturing');
    if(g0&&typeof g0.x==='number'&&Math.abs(e.clientX-g0.x)<12&&Math.abs(e.clientY-g0.y)<12&&Date.now()-g0.t<350){
      var now=Date.now();
      if(now-lastTap<400){
        if(scale>1){scale=1;tx=0;ty=0;}
        else{scale=2.4;var r=img.getBoundingClientRect();tx=(r.left+r.width/2-e.clientX)*(scale-1)/scale;ty=(r.top+r.height/2-e.clientY)*(scale-1)/scale;clampPan();}
        apply();lastTap=0;
      } else { lastTap=now; }
    }
    g0=null;
  } else { g0=null; }
}
document.addEventListener('pointerup',up);
document.addEventListener('pointercancel',up);
document.addEventListener('click',function(e){if(e.target&&e.target.closest&&e.target.closest('.mp-lb-prev,.mp-lb-next,.mp-lb-close'))reset();});
document.addEventListener('load',function(e){if(e.target&&e.target.tagName==='IMG'&&e.target.closest&&e.target.closest('.mp-lightbox')){img=e.target;reset();}},true);
})();

/* === SWIPE-NAV 2026-07-06: horizontal touch swipe on the mobile PDP gallery (.mp-gallery-main).
   Reuses the existing [data-mp-prev]/[data-mp-next] click path so slide/thumb/lightbox state stays in one place. */
(function(){'use strict';
var gal=document.querySelector('.mp-gallery-main');
if(!gal)return;
var prevBtn=document.querySelector('[data-mp-prev]'),nextBtn=document.querySelector('[data-mp-next]');
if(!prevBtn&&!nextBtn)return;
gal.style.touchAction='pan-y pinch-zoom';
var swipeId=null,swipeMulti=false,sx=0,sy=0,st=0;
gal.addEventListener('pointerdown',function(e){
  if(e.pointerType!=='touch')return;
  if(swipeId!==null){swipeMulti=true;return;}
  var lb=document.querySelector('.mp-lightbox');
  if(lb&&!lb.hidden)return;
  if(e.target&&e.target.closest&&e.target.closest('.mp-gallery-nav'))return;
  swipeId=e.pointerId;swipeMulti=false;sx=e.clientX;sy=e.clientY;st=Date.now();
});
function endSwipe(e){
  if(swipeId===null||e.pointerId!==swipeId)return;
  var multi=swipeMulti;swipeId=null;swipeMulti=false;
  if(e.type!=='pointerup'||multi)return;
  var dx=e.clientX-sx,dy=e.clientY-sy,dt=Date.now()-st;
  if(Math.abs(dx)>48&&Math.abs(dx)>2*Math.abs(dy)&&dt<600){
    var btn=dx<0?nextBtn:prevBtn;
    if(btn)btn.click();
  }
}
window.addEventListener('pointerup',endSwipe);
window.addEventListener('pointercancel',endSwipe);
})();
